import React from 'react';
import { SITE } from '@credits-utils/constants/lib/misc';
import { useI18n } from 'nordic/i18n';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import TrackingLink from '../../../../../components/TrackingLink';
import { getDisclaimerSectionContent } from '../../content/disclaimerSection';
import { TARGET } from '../../../../../constants';

const DisclaimerSale = () => {
  const { helpLinks, siteId, tracks } = React.useContext(SharedPropsContext);
  const { i18n } = useI18n();
  const { sale } = getDisclaimerSectionContent({ i18n });

  const financialUserInfoLink = (
    <TrackingLink
      href={helpLinks.financialUserInfo}
      target={TARGET.BLANK}
      trackInfoMelidata={
        tracks.melidata.events.buyersPage.disclaimerSection
          .goToFinancialUserInfo
      }
    >
      {sale.paragraph2.second}
    </TrackingLink>
  );

  const disclaimerSaleMLB = () => (
    <>
      <div>{sale.MLB.paragraph1}</div>
      <br />
      <div>{sale.MLB.paragraph2}</div>
    </>
  );

  const disclaimerSaleMLA = () => (
    <>
      <div>{sale.paragraph1}</div>
      <div>
        {sale.paragraph2.first} {financialUserInfoLink}
        {sale.paragraph2.endText}
      </div>
      <br />
      <div>{sale.paragraph3}</div>
      <div>{sale.paragraph4}</div>
    </>
  );

  const disclaimerSaleMLM = () => (
    <>
      <div>{sale.paragraph1}</div>
      <br />
      <div>{sale.paragraph3}</div>
      <div>{sale.paragraph4}</div>
    </>
  );

  const saleDisclaimersBySite = {
    [SITE.MLB]: disclaimerSaleMLB(),
    [SITE.MLA]: disclaimerSaleMLA(),
    [SITE.MLM]: disclaimerSaleMLM(),
  };

  return (
    <div className="disclaimer-section__sale">
      {saleDisclaimersBySite[siteId.toString()]}
    </div>
  );
};

export default DisclaimerSale;
